export default "__VITE_ASSET__e681deba__"